// client/src/main.jsx
// SPA bootstrap. Wraps the app in:
//   - QueryClientProvider — TanStack Query for all server-state. Sensible
//     defaults for an internal admin app: refetchOnWindowFocus off (no need
//     for desktop tabs to constantly poll), 30s stale.
//   - BrowserRouter — react-router v7. The whole SPA is rendered at /
//     (Express serves the dist as static and falls through to index.html
//     for unknown paths).

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.jsx';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);
